<div class="divHome">
    <h1>Home Warehouse</h1>
    <div class="divGridHome">
<!--        <div class="elementGrid" (click)="navigateTo('/almacen-insumos')" routerLinkActive="active">-->
<!--            <p>ALMACEN INSUMOS</p>-->
<!--            <mat-icon class="icon"> local_grocery_store</mat-icon>-->
<!--        </div>-->

        <div class="elementGrid" (click)="navigateTo('/almacen-equipos')" routerLinkActive="active">
            <p>ALMACEN EQUIPOS</p>
            <mat-icon class="icon"> directions_bike</mat-icon>
        </div>

        <div class="elementGrid" (click)="navigateTo('/almacen-menajeria')" routerLinkActive="active">
            <p>ALMACEN MENAJERÍA</p>
            <mat-icon class="icon"> restaurant_menu</mat-icon>
        </div>


    </div>
</div>
